import { icon, Icon } from '../lib/fa-icons.js';
/*
Place this widget just before the closing tag of the .Article__Main element
*/

import Widget from "./base.js";
import { Component } from "preact";
import { getCookie, setCookie } from "tpm-utils";
import { MembershipDriveCount25Widget } from "./membership-drive-count-25.js";

export class MembershipDriveModal26Widget extends Widget {
	componentWillMount() {
		this.toSm = this.toSm.bind(this);
		this.state.size =
			getCookie("tpm_membership_drive_size") === "sm" || this.props.fp
				? "sm"
				: "lg";

		if (this.state.size === "lg") {
			document
				.querySelector(".Primary")
				.setAttribute("style", "padding: 0 !important");
		}
	}

	componentDidMount() {
		const isSm = getCookie("tpm_membership_drive_size") === "sm";

		if (!isSm) {
			document.body.classList.add("freeze");
		}

		document
			.querySelector("div:has(> .MembershipDriveModal26Widget)")
			.classList.add(
				"MembershipDriveModal26WidgetContainer",
				isSm ? "--sm" : "--lg"
			);
	}

	toSm() {
		setCookie("tpm_membership_drive_size", "sm", 0.5); //12 hrs
		this.setState({ size: "sm" }, () => {});
		document.body.classList.remove("freeze");
		document
			.querySelector(".MembershipDriveModal26WidgetContainer")
			.classList.remove("--lg");
		document
			.querySelector(".MembershipDriveModal26WidgetContainer")
			.classList.add("--sm");
	}

	href(medium = "not_defined") {
		const source = "onsite";
		const campaign = "drive26";

		const id = "memberdrive";
		const promo = this.state.views > 9 ? "&promo=25OffAny" : "";

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}&utm_id=${id}${promo}`;
	}

	button(standalone = false, hideLogo = false) {
		return (
			<div
				class={`MembershipDriveModal26__CTA Membership26Banner__CTA ${
					standalone ? "--standalone" : ""
				}`}
			>
				<a
					class={`Membership26Banner__Button --${
						hideLogo ? "hide-logo" : "show-logo"
					} Button --red`}
					href={this.href()}
				>
					Get 25% Off Annual Memberships
					<img
						class={`Membership26Banner__Logo --hide-xl ${
							hideLogo ? "--hide" : ""
						}`}
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-26/logo.png`}
						alt="TPM Member Drive"
					/>
				</a>
			</div>
		);
	}

	renderContent() {
		if (this.state.size === "sm") {
			return (
				<div
					className={`MembershipDriveModal26__Small  ${
						this.props.fp ? "--fp" : ""
					}`}
				>
					<div class="Membership26Banner --contained --modal">
						<div class="Membership26Banner__Text --contained --modal">
							Help Us Reach <mark class="highlight">1000</mark> New&nbsp;Members
						</div>
						<MembershipDriveCount25Widget />

						{this.button(true)}
					</div>
				</div>
			);
		}

		const urlParams = new URLSearchParams(window.location.search);
		const variant = urlParams.get("variant");
		if (variant === "a") return this.renderVersionA();
		if (variant === "b") return this.renderVersionB();
		if (variant === "c") return this.renderVersionC();

		return this.renderVersionC();

		const rand = Math.random();
		if (rand < 0.34) return this.renderVersionA();
		else if (rand < 0.64) return this.renderVersionB();
		else return this.renderVersionC();
	}

	renderVersionA() {
		return (
			<div className={`MembershipDriveModal26`}>
				<div className={`MembershipDriveModal26__Side --left-a`}></div>
				<div className={`MembershipDriveModal26__Body --normal`}>
					<div
						className="MembershipDriveModal26__Close"
						onClick={this.toSm.bind(this)}
					>
						<Icon name="xmark" style="solid" />
					</div>
					<div className="MembershipDriveModal26__Heading">
						HELP US CHRONICLE THE{" "}
						<mark className="highlight">NATIONAL CRISIS</mark>
					</div>

					<div className="MembershipDriveModal26__Text --lg">
						<p>
							Accountability might be in short supply lately, but the Trump
							administration won’t be around forever.
						</p>

						<p>
							With many of our democratic institutions in crisis and elites
							capitulating to the whims of the White House, it’s critical that
							an honest record of the present be kept to ensure perseverance of
							the law in the future. Yet there are fewer and fewer news
							organizations capable of doing the job. 
						</p>

						<p>
							At TPM, our mission is to chronicle unconstitutional abuses of
							power and blatant corruption. Beyond just observing and
							documenting, we’re doing the aggressive reporting required to get
							to the bottom of what we view as various plots against the
							American republic.
						</p>

						<p>
							Becoming a member not only helps provide the financial resources
							to enable this work but, perhaps more importantly, is a sign of
							solidarity that you are with us on this mission.
						</p>
					</div>

					<div className="MembershipDriveModal26__Text --sm">
						<p>
							Accountability might be in short supply lately, but the Trump
							administration won't be around forever.
						</p>

						<p>
							At TPM, our mission is to chronicle unconstitutional abuses of
							power and blatant corruption. Beyond just observing and
							documenting, we're doing the aggressive reporting required to get
							to the bottom of what we view as various plots against the
							American republic.
						</p>

						<p>
							Becoming a member not only helps provide the financial resources
							to enable this work but, perhaps more importantly, is a sign of
							solidarity that you are with us on this mission.
						</p>
					</div>

					{this.button()}

					<div
						className="MembershipDriveModal26__Shrink"
						onClick={this.toSm.bind(this)}
					>
						No thanks
					</div>
				</div>
				<div className={`MembershipDriveModal26__Side --right-a`}></div>
			</div>
		);
	}

	renderVersionB() {
		return (
			<div className={`MembershipDriveModal26`}>
				<div className={`MembershipDriveModal26__Side --left-b`}></div>
				<div className={`MembershipDriveModal26__Body --normal`}>
					<div
						className="MembershipDriveModal26__Close"
						onClick={this.toSm.bind(this)}
					>
						<Icon name="xmark" style="solid" />
					</div>
					<div className="MembershipDriveModal26__Heading">
						The Trump Administration <mark className="highlight">Won’t</mark> Be
						Around Forever
					</div>

					<div className="MembershipDriveModal26__Text --lg">
						<p>
							Accountability for the lawless Trump administration can’t wait
							until his term ends. It begins long before that with the
							journalists who seek out abuses of power so that when the time
							comes, we have an honest record of what happened.
						</p>

						<p>
							With many of our democratic institutions in crisis and elites
							capitulating to the whims of the White House, the task of creating
							such a record is more important than ever. Yet there are fewer and
							fewer news organizations capable of doing the job.
						</p>

						<p>
							At TPM, our mission is to chronicle unconstitutional abuses of
							power and blatant corruption. Beyond just observing and
							documenting, we’re doing the aggressive reporting required to get
							to the bottom of what we view as various plots against the
							American republic.
						</p>
						<p>
							Becoming a member not only helps provide the financial resources
							to enable this work but, perhaps more importantly, is a sign of
							solidarity that you are with us on this mission.
						</p>
					</div>

					<div className="MembershipDriveModal26__Text --sm">
						<p>
							Accountability for the lawless Trump administration can't wait
							until his term ends.
						</p>

						<p>
							At TPM, our mission is to chronicle unconstitutional abuses of
							power and blatant corruption. Beyond just observing and
							documenting, we're doing the aggressive reporting required to get
							to the bottom of what we view as various plots against the
							American republic.
						</p>

						<p>
							Becoming a member not only helps provide the financial resources
							to enable this work but, perhaps more importantly, is a sign of
							solidarity that you are with us on this mission.
						</p>
					</div>

					{this.button()}

					<div
						className="MembershipDriveModal26__Shrink"
						onClick={this.toSm.bind(this)}
					>
						No thanks
					</div>
				</div>
				<div className={`MembershipDriveModal26__Side --right-b`}></div>
			</div>
		);
	}

	renderVersionC() {
		return (
			<div className={`MembershipDriveModal26 --c`}>
				<div className={`MembershipDriveModal26__Side --left-c --empty`}></div>
				<div className={`MembershipDriveModal26__Body --c`}>
					<div
						className="MembershipDriveModal26__Close"
						onClick={this.toSm.bind(this)}
					>
						<Icon name="xmark" style="solid" />
					</div>
					<MembershipDriveCount25Widget logoPos="top" size="large" />
					<div className="MembershipDriveModal26__Heading --center --c">
						Help Us Reach <mark className="highlight">1000</mark>{" "}
						New&nbsp;Members
					</div>

					<div className="MembershipDriveModal26__Text --lg --c">
						<p>
							At TPM, our mission is to chronicle unconstitutional abuses of
							power and blatant corruption. Beyond just observing and
							documenting, we’re doing the aggressive reporting required to get
							to the bottom of what we view as various plots against the
							American republic.
						</p>

						<p>
							Becoming a member not only helps provide the financial resources
							to enable this work but, perhaps more importantly, is a sign of
							solidarity that you are with us on this mission.
						</p>
					</div>

					<div className="MembershipDriveModal26__Text --sm --c">
						<p>
							At TPM, our mission is to chronicle unconstitutional abuses of
							power and blatant corruption. Beyond just observing and
							documenting, we’re doing the aggressive reporting required to get
							to the bottom of what we view as various plots against the
							American republic.
						</p>

						<p>
							Becoming a member not only helps provide the financial resources
							to enable this work but, perhaps more importantly, is a sign of
							solidarity that you are with us on this mission.
						</p>
					</div>

					{this.button(false, true)}

					<div
						className="MembershipDriveModal26__Shrink"
						onClick={this.toSm.bind(this)}
					>
						No thanks
					</div>
				</div>
				<div className={`MembershipDriveModal26__Side --right-c --empty`}></div>
			</div>
		);
	}
}
